import * as yup from "yup";

export const CREATE_REFERENCE_INITIAL_VALUES = {
  name: "",
  description: "",
  type: "",
  scope: "",
  drafter: "",
  approver: "",
};

export const CREATE_REFERENCE_VALIDATION_SCHEMA = {
  name: yup
    .string()
    .trim()
    .required("Reference Source Name is a required field."),
  description: yup.string().trim(),
  type: yup.object().required("Reference Type is a required field."),
  scope: yup.object().required("Scope is a required field."),
  drafter: yup.object().required("Drafter is a required field."),
  approver: yup.object().required("Approver is a required field."),
};

export const CREATE_REFERENCE_VALUES_VALIDATION_SCHEMA = yup.object({
  referenceValues: yup.array().of(
    yup.object().shape({
      name: yup.string().trim().required("Value is required"),
      start_date: yup.date().required("Start Date is a required field"),
      end_date: yup
        .date()
        .required("End Date is a required field")
        .min(yup.ref("start_date"), "Start Date must be before End Date"),
    })
  ),
});
